export default __webpack_public_path__ + "static/media/472.23b2ac42.png";